var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99333 7.37335C10.2807 7.20742 10.2807 6.79258 9.99333 6.62665L1.32666 1.62294C1.03926 1.45701 0.68 1.66443 0.68 1.9963V12.0037C0.68 12.3356 1.03926 12.543 1.32667 12.3771L9.99333 7.37335Z",
    stroke: "#7E8CA8",
    strokeWidth: 1.36
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.85c91398e194f0de05974263bf755090.svg";
export { ForwardRef as ReactComponent };